import googleFontsService from '../../../services/googleFontsService';

const fontService = {
  async list(params = {}) {
    return googleFontsService.list(params);
  },

  async search(queryText, params = {}) {
    return googleFontsService.search(queryText, params);
  },
};

export default fontService;
